import React from 'react';
import ReactDOM from 'react-dom';
import Modal from 'react-modal';

const customStyles = {
    overlay: {
        zIndex: '2',
        backgroundColor: 'rgba(0,0,0,0.6)',

    },
    content: {
        position: 'absolute',
        top: '20%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
    },
};
Modal.setAppElement("#root");

const CustomEditModal = ({open,person}) => {
    let subtitle;
    const [modalIsOpen, setIsOpen] = React.useState(open);
console.log(person)
    function openModal() {
        setIsOpen(true);
    }

    function afterOpenModal() {
        // references are now sync'd and can be accessed.
        subtitle.style.color = '#f00';
    }

    function closeModal() {
        setIsOpen(false);
    }

    return (
        <div>
            <button onClick={openModal}>Open Modal</button>
            <Modal
                isOpen={modalIsOpen}
                onAfterOpen={afterOpenModal}
                onRequestClose={closeModal}
                style={customStyles}
                contentLabel="Example Modal"
            >
                <button target="_self" className="modal-content--cross" >
                    <img src={require("../../../src/assets/images/cross/Group 6926.svg").default} alt=""/>
                </button>
                <h1 className="text-jost-sb-24">Edit Incident </h1>
                <div className="report_Form">
                    <input className="form__input-md-wt" type="text"/>
                    <button className="res-btn-lightgrn">edit</button>
                </div>
                <div className="reports_table">

                </div>
            </Modal>
        </div>
    );
}

export default CustomEditModal
